/**
 * Production hostname gate for third-party tracking libraries.
 *
 * Preview deploys, localhost, and other non-production hosts must not
 * fire ad pixels or send data to third-party platforms (Meta, TikTok,
 * Google, Klaviyo) — they pollute audiences and skew ad attribution.
 *
 * Internal analytics (our own Supabase) is NOT gated here; preview
 * traffic there is harmless.
 */

const PRODUCTION_HOSTS: Record<string, true> = {
  "oariaskin.com": true,
  "www.oariaskin.com": true,
};

export function isProductionHost(): boolean {
  if (typeof window === "undefined") return false;
  return window.location.hostname in PRODUCTION_HOSTS;
}